import {
  getStoreAnswerPaperCommon,
  getInspectionsTasksDomain
} from "@/graphql/Other.gql";
export default {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    async getStoreAnswerPaperCommon(
      { commit, state, rootState }: any,
      data?: any
    ) {
      const {
        data: { api }
      } = await rootState.gql.query({
        query: getStoreAnswerPaperCommon,
        variables: data
      });
      return api || {};
    },
    async getInspectionsTasksDomain(
      { commit, state, rootState }: any,
      data?: any
    ) {
      // 查看任务详情
      const {
        data: { api }
      } = await rootState.gql.query({
        query: getInspectionsTasksDomain,
        variables: data
      });
      return api || {};
    }
  },
  mutations: {}
};
